var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8384 3.65826C11.7362 3.76157 11.5966 3.81989 11.4514 3.81989C11.3057 3.81989 11.1667 3.76158 11.0639 3.65826L9.27006 1.85784V3.27107C9.27006 5.58607 8.35088 7.80641 6.71449 9.44367C5.07857 11.0804 2.85934 12 0.544971 12C0.243857 12 0 11.756 0 11.4548C0 11.1535 0.243857 10.909 0.544971 10.909C2.56998 10.909 4.51162 10.1044 5.94351 8.67177C7.37501 7.23956 8.17962 5.29655 8.17962 3.27105V1.85783L6.38573 3.65824H6.38522C6.17153 3.87204 5.82492 3.87204 5.61122 3.65824C5.39702 3.44444 5.39702 3.09767 5.61122 2.88334L8.33758 0.155618C8.38921 0.106004 8.45056 0.0671322 8.51753 0.0410465C8.65045 -0.0136822 8.79921 -0.0136822 8.93214 0.0410465C8.99911 0.0671322 9.05994 0.106004 9.11209 0.155618L11.8384 2.88334C11.9417 2.98615 12 3.12528 12 3.27104C12 3.41631 11.9417 3.55597 11.8384 3.65826Z",
    fill: "#29363C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/up-icon.16df7d87bab9b3a78af33fb061aba46b.svg";
export { ForwardRef as ReactComponent };